<template>
  <div>
    <div class="top-bar">
      <span>
        <i class="left" @click="back()"></i>
      </span>
      <span class="heading_new">Arrear Increment override</span>
      <span class="spacer" />
    </div>
    <div class="main-container">
      <div class="rectangle margin-b-m">
        <label class="upload-digitally-sig">
          <span class="info-icon">i</span>
          The components listed includes all CTC components and Fixed non CTC components where arrears are applicable.
        </label>
      </div>
      <selected-employee-card
        :empName="emp.empName"
        :empId="emp.empId"
        :empMail="emp.empMail"
        :typeOfPay="emp.typeOfPay"
      />
      <div class="row margin-t-s">
        <div class="col-3">
          <txt
            label="Month"
            name="month"
            v-model="currentMonth"
            :disabled="true"
            :autofocus="false"
          />
        </div>
        <div class="col-12 margin-t-s">
          <span class="noteText">
            <strong>Note:</strong> The List of Components Dislpayed Below are All the CTC. Components (Excluding Statuory Components) &amp; Fixed Non CTC Components, who’s Arrears are Applicable in the Current Month.
          </span>
        </div>
      </div>
      <div class="margin-t-s">
        <ul class="table-header header">
          <li class="table-header-item">Month</li>
          <li class="table-header-item">Components</li>
          <li class="table-header-item">Arrear Amount</li>
          <li class="table-header-item">Override Amount</li>
          <li class="table-header-item">Difference Amount</li>
          <li class="table-header-item">Actions</li>
        </ul>
        <div class="row-div" v-for="(item,index) in arrearTableData" :key="index">
          <ul class="table-row">
            <li class="table-row-item">{{item.month}}</li>
            <li class="table-row-item">{{item.components.length ? "All": "-"}}</li>
            <li class="table-row-item">{{item.amount}}</li>
            <li class="table-row-item">{{item.override_amount}}</li>
            <li class="table-row-item">{{item.difference_amount}}</li>
            <li class="table-row-item">
              <a
                href="javascript:void(0)"
                @click="item.showComponents = !item.showComponents"
              >view details</a>
            </li>
          </ul>
          <div v-if="item.showComponents">
            <ul class="table-row" v-for="(component, idx) in item.components" :key="idx">
              <li class="table-row-item"></li>
              <li class="table-row-item">{{component.name}}</li>
              <li class="table-row-item">{{component.arrear_amount}}</li>
              <li class="table-row-item">
                <txt
                  type="number"
                  :name="'overrideamount'+index+idx"
                  v-model="component.override_amount"
                  @change="component.difference_amount = component.arrear_amount-component.override_amount; calculateTotal(index)"
                  v-validate="`max_value:${component.arrear_amount}`"
                  :classname="errors.has('overrideamount'+index+idx)"
                  errormsg="this amount can not be greater than arrear amount"
                />
              </li>
              <li class="table-row-item">
                <span
                  :class="component.difference_amount < 0 ?'text-red': 'text-green'"
                >{{component.difference_amount}}</span>
              </li>
              <li class="table-row-item"></li>
            </ul>
            <ul class="table-row">
              <li class="table-row-item"></li>
              <li class="table-row-item">
                <b>Total</b>
              </li>
              <li class="table-row-item">{{item.total_Arrear_amount}}</li>
              <li class="table-row-item">{{item.total_override_amount}}</li>
              <li class="table-row-item">{{item.total_difference_amount}}</li>
              <li class="table-row-item"></li>
            </ul>
          </div>
        </div>
      </div>
      <div class="row margin-t-l">
        <div class="col-3">
          <tl-radio
            label="Schedule Balance Amount"
            name="balanceAmount"
            id="schedule"
            value="schedule"
            v-model="balance_amount"
          ></tl-radio>
        </div>
        <div class="col-3">
          <tl-radio
            label="Ignore Balance Amount"
            name="balanceAmount"
            id="ignore"
            value="ignore"
            v-model="balance_amount"
          ></tl-radio>
        </div>
      </div>
      <div class="margin-t-m" v-if="balance_amount == 'schedule'">
        <div class="row">
          <div class="col-3">
            <tl-select
              label="Financial Year"
              name="financial_year"
              :options="['2019-20', '2020-21']"
            />
          </div>
          <div class="col-3">
            <tl-select
              label="Month"
              name="month"
              :options="effMonthOptions"
              :multiple="true"
              @change="getBalanceAmountList($event)"
            />
          </div>
        </div>
        <div class="margin-t-s" v-if="balanceAmountTableData.length">
          <ul class="table-header header">
            <li class="table-header-item">Month</li>
            <li class="table-header-item">Components</li>
            <li class="table-header-item">Difference Amount</li>
            <li class="table-header-item">Override Amount</li>
            <li class="table-header-item">Balance Amount</li>
            <li class="table-header-item">Actions</li>
          </ul>
          <div class="row-div" v-for="(item,index) in balanceAmountTableData" :key="index">
            <ul class="table-row">
              <li class="table-row-item">{{item.month}}</li>
              <li class="table-row-item">{{item.components.length ? "All": "-"}}</li>
              <li class="table-row-item">{{item.amount}}</li>
              <li class="table-row-item">{{item.override_amount}}</li>
              <li class="table-row-item">{{item.difference_amount}}</li>
              <li class="table-row-item">
                <a
                  href="javascript:void(0)"
                  @click="item.showComponents = !item.showComponents"
                >view details</a>
              </li>
            </ul>
            <div v-if="item.showComponents">
              <ul class="table-row" v-for="(component, idx) in item.components" :key="idx">
                <li class="table-row-item"></li>
                <li class="table-row-item">{{component.name}}</li>
                <li class="table-row-item">{{component.difference_amount}}</li>
                <li class="table-row-item">
                  <txt
                    type="number"
                    :name="'balanceoverrideamount'+index+idx"
                    v-model="component.override_amount"
                    v-validate="`max_value:${component.difference_amount}`"
                    :classname="errors.has('balanceoverrideamount'+index+idx)"
                    errormsg="this amount can not be greater than difference amount"
                    @change="component.balance_amount = component.difference_amount - component.override_amount;calculateBalacne(index, idx, component.balance_amount);calculateBalanceTotal(index);"
                  />
                </li>
                <li class="table-row-item"><span
                  :class="component.balance_amount < 0 ?'text-red': 'text-green'"
                >{{component.balance_amount}}</span></li>
                <li class="table-row-item"></li>
              </ul>
              <ul class="table-row">
                <li class="table-row-item"></li>
                <li class="table-row-item">
                  <b>Total</b>
                </li>
                <li class="table-row-item">{{item.total_difference_amount}}</li>
                <li class="table-row-item">{{item.total_override_amount}}</li>
                <li class="table-row-item">{{item.total_balance_amount}}</li>
                <li class="table-row-item"></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <bottom-action-container >
      <template slot="end">
        <btn-grp>
          <btn text="Cancel" type="secondary" @click="back" />
          <btn text="Update" type="primary" @click="submit" />
        </btn-grp>
      </template>
    </bottom-action-container>
  </div>
</template>

<script>
import SelectedEmployeeCard from "@/components/dashboard/selectedEmployeeCard.vue";
export default {
  components: {
    SelectedEmployeeCard
  },
  data() {
    return {
      emp: {
        empName: "Chetna Garg",
        empId: "745432",
        empMail: "",
        dates: "01, 04/04/2018",
        lop: "02",
        typeOfPay: "LOP"
      },
      balance_amount: "schedule",
      currentMonth: "",
      effMonthOptions: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ],
      arrearTableData: [
        {
          month: "April",
          components: [
            {
              name: "Basic",
              arrear_amount: 10000,
              override_amount: null,
              difference_amount: null
            },
            {
              name: "LTA",
              arrear_amount: 10000,
              override_amount: null,
              difference_amount: null
            }
          ],
          amount: "-",
          override_amount: "-",
          difference_amount: "-",
          total_arrear_amount: null,
          total_override_amount: null,
          total_difference_amount: null,
          showComponents: false
        },
        {
          month: "May",
          components: [
            {
              name: "Basic",
              arrear_amount: 10000,
              override_amount: null,
              difference_amount: null
            },
            {
              name: "LTA",
              arrear_amount: 10000,
              override_amount: null,
              difference_amount: null
            }
          ],
          amount: "-",
          override_amount: "-",
          difference_amount: "-",
          total_arrear_amount: null,
          total_override_amount: null,
          total_difference_amount: null,
          showComponents: false
        },
        {
          month: "June",
          components: [
            {
              name: "Basic",
              arrear_amount: 10000,
              override_amount: null,
              difference_amount: null
            },
            {
              name: "LTA",
              arrear_amount: 10000,
              override_amount: null,
              difference_amount: null
            }
          ],
          amount: "-",
          override_amount: "-",
          difference_amount: "-",
          total_arrear_amount: null,
          total_override_amount: null,
          total_difference_amount: null,
          showComponents: false
        }
      ],
      balanceAmountTableData: []
    };
  },
  computed: {},
  activated() {
    let date = new Date();
    this.currentMonth = this.effMonthOptions[date.getMonth()];
  },
  methods: {
    back() {
      this.$router.go(-1);
    },
    submit() {
      //console.log(this.arrearTableData);
    },
    getBalanceAmountList(months) {
      //console.log(months);
      let tableData=[];
      months.forEach((element, index) =>{
        tableData[index]={
          components: this.arrearTableData[0].components.map(item => {return {
            name: item.name,
            difference_amount:0,
            override_amount:0,
            balance_amount:0
          }}),
          month: element,
          amount: "-",
          override_amount: "-",
          difference_amount: "-",
          total_balance_amount: 0,
          total_override_amount: 0,
          total_difference_amount: 0,
          showComponents: false
        };
      });
      this.arrearTableData.forEach((element,index) => {
        element.components.forEach((item,idx) =>{
          tableData[0].components[idx].difference_amount += item.difference_amount
        })
      });
      this.balanceAmountTableData = tableData;
      //console.log(tableData);
      
    },
    calculateBalacne(monthIndex, compIndex, value) {
      if (monthIndex < this.balanceAmountTableData.length - 1) {
        this.balanceAmountTableData[monthIndex + 1].components[
          compIndex
        ].difference_amount = value;
      }
    },
    calculateTotal(index, value) {
      let totalOverrideAmount = 0;
      let totalDifferenceAmount = 0;
      this.arrearTableData[index].components.forEach(element => {
        totalOverrideAmount += element.override_amount;
        totalDifferenceAmount += element.difference_amount;
      });
      this.arrearTableData[index].total_override_amount = totalOverrideAmount;
      this.arrearTableData[index].total_difference_amount = totalDifferenceAmount;
    },
    calculateBalanceTotal(index) {
      let totalOverrideAmount = 0;
      let totalBalanceAmount = 0;
      this.balanceAmountTableData[index].components.forEach(element => {
        totalOverrideAmount += element.override_amount;
        totalBalanceAmount += element.balance_amount;
      });
      this.balanceAmountTableData[
        index
      ].total_override_amount = totalOverrideAmount;
      this.balanceAmountTableData[
        index
      ].total_balance_amount = totalBalanceAmount;
    }
  }
};
</script>

<style lang="scss" scoped>
.top-bar {
  height: auto;
  padding: 20px;
  background-color: #34c0be;
  display: flex;
}
.heading_new {
  width: auto;
  font-size: 24px;
  font-weight: bold;
  color: #ffffff;
  height: auto;
}
.left {
  border: solid white;
  border-width: 0 2px 2px 0;
  padding: 5px;
  transform: rotate(135deg);
  -webkit-transform: rotate(135deg);
  margin-top: 9px;
  margin-right: 15px;
  cursor: pointer;
}
.rectangle {
  height: 50px;
  border-radius: 4px;
  background-color: #f9f9f9;
  padding: 15px 30px;
}

.upload-digitally-sig {
  font-family: Montserrat;
  font-size: 12px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #646464;
}
.info-icon {
  border: 1px #646464 solid;
  border-radius: 100%;
  width: 20px;
  height: 20px;
  margin: 0 5px 0 0;
  display: inline-block;
  vertical-align: middle;
  font-size: 15px;
  color: #646464;
}
.noteText {
  font-size: 12px;
  color: #6e6e6e;
}

.header {
  background-color: #dedede;
}
.table-header {
  display: inline-flex;
  width: 100%;
  padding: 10px 0px;
  .table-header-item {
    padding: 5px 10px;
    width: 100%;
    color: #000000;
    opacity: 0.68;
    font-weight: 500;
  }
}
.row-div {
  &:nth-child(odd) {
    background-color: #fbfbfb;
  }
}
.table-row {
  display: inline-flex;
  width: 100%;
  padding: 10px 0px;

  .table-row-item {
    padding: 5px 10px;
    width: 100%;
    color: #000000;
    opacity: 0.68;
    font-weight: 500;
    a {
      color: blue;
      text-decoration: underline;
    }
  }
}
.text-red {
  color: red;
}
.text-green {
  color: green;
}
.d_heading {
  font-size: 14px;
  font-weight: 600;
  opacity: 0.68;
  color: #646464;
}
</style>

